package dev.lingvo.shared.screenshots.render

import dev.lingvo.shared.screenshots.doc.BackgroundLayer
import dev.lingvo.shared.screenshots.doc.Palette
import dev.lingvo.shared.screenshots.geom.Rect

internal fun paintBackground(layer: BackgroundLayer, rect: Rect, palette: Palette, slot: Int, surface: Surface) {
    val path = Paths.rect(rect)
    surface.fill(path, resolvePaint(layer.fill, rect, palette, slot))
    layer.blobs.forEach { blob ->
        val color = resolveColor(blob.color, palette, slot)
        surface.fill(path, ResolvedPaint.Radial(rect.x + blob.cx * rect.w, rect.y + blob.cy * rect.h,
            blob.r * minOf(rect.w, rect.h), listOf(0.0 to color, 1.0 to (color and 0xFFFFFF))))
    }
    layer.grain?.let { surface.fill(path, ResolvedPaint.Noise(it.seed, it.amount)) }
}
